import React from 'react';
import { Box, Divider } from '@mui/material';
import AlertsInbox from '../AlertsInbox';
import NotificationPreferencesPanel from './NotificationPreferencesPanel';

/**
 * Settings → Notifications: full inbox plus personal/team notification preferences.
 */
export default function NotificationsPage({
  userData,
  alertsRemote,
  focusedAlertId,
  onFocusedAlertChange,
  onCreateTicketFromAlert,
  showAlertsOnOverview,
  onChangeShowAlertsOnOverview,
}) {
  return (
    <Box>
      <AlertsInbox
        userData={userData}
        alertsRemote={alertsRemote}
        focusedAlertId={focusedAlertId}
        onFocusedAlertChange={onFocusedAlertChange}
        onCreateTicketFromAlert={onCreateTicketFromAlert}
      />
      <Divider sx={{ my: 4 }} />
      <NotificationPreferencesPanel
        userData={userData}
        showAlertsOnOverview={showAlertsOnOverview}
        onChangeShowAlertsOnOverview={onChangeShowAlertsOnOverview}
        embedded
      />
    </Box>
  );
}
